import { Guid } from "client_legacy/ndaw/guid";
import { HttpClient } from "../httpClient";
import { SupportInformationViewModel } from "../Support/support";

export type SignInModel = {
	emailAddress: string;
	password: string;
};

export type SignInResult =
	{
		wasSuccessful: false;
	}
	|
	{
		wasSuccessful: true;
		redirectUrl: string;
	};

export function signIn(model: SignInModel, signal?: AbortSignal): Promise<SignInResult> {
	return new HttpClient()
		.post<SignInResult>(
			"/admin/SignIn",
			model,
			{ signal }
		);
}

export type ClearSharedDataRequestModel = {
	cache: boolean;
	temporaryData: boolean;
};

export function clearSharedData(
	model: ClearSharedDataRequestModel,
	signal?: AbortSignal
): Promise<void> {
	return new HttpClient()
		.post<void>(
			"/admin/ClearSharedData",
			model,
			{ signal }
		);
}

export type ClearSharedDataForEnvironmentRequestModel = {
	environmentId: Guid;
	cache: boolean;
	temporaryData: boolean;
};

export function clearEnvironmentSharedData(
	model: ClearSharedDataForEnvironmentRequestModel,
	signal?: AbortSignal
): Promise<void> {
	return new HttpClient()
		.post<void>(
			"/admin/ClearEnvironmentSharedData",
			model,
			{ signal }
		);
}

export type EnvironmentModel = {
	id: Guid;
	name: string;
	isActive: boolean;
	partnerName: string | null;
};

export type InstanceOperatorPermissionsViewModel = {
	canViewLogs: boolean;
	canClearCache: boolean;
	canDownloadUserReport: boolean;
};

export type InstanceOperatorMenuPageViewModel = {
	supportInfo: SupportInformationViewModel;
	isMiniProfilerEnabled: boolean;
	permissions: InstanceOperatorPermissionsViewModel;
};

export type InstanceOperatorEnvironmentsPageViewModel = {
	environments: readonly EnvironmentModel[];
	canClearCache: boolean;
};
